import Swiper from 'swiper';
import {
    EffectCards,
    EffectFade,
    Navigation,
    Pagination,
} from 'swiper/modules';

class EventsSlider {
    constructor(el) {
        if (!this.set(el)) return;

        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' &&
                !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.slider = this.root.querySelector('[data-events-slider]');
        this.descriptions = this.root.querySelector(
            '[data-events-events-descriptions]'
        );

        this.pagination = this.root.querySelector(
            '[data-events-slider-pagination]'
        );

        this.prevEl = this.root.querySelector('[data-events-prev]');
        this.nextEl = this.root.querySelector('[data-events-next]');

        this.swiper = null;
        this.descSwiper = null;

        return true;
    }

    init() {
        this.onResize();
        this.initDescriptionSlider();
        this.initWindow();
    }

    initSlider() {
        if (!this.slider) return;

        const swiperOptions = {
            modules: [Pagination, Navigation],
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
            pagination: {
                el: this.pagination,
                clickable: true,
                type: 'bullets',
                bulletClass: 'slider-pagination__bullet',
                bulletActiveClass: 'active',
            },
        };

        if (this.nextEl && this.prevEl) {
            swiperOptions.navigation = {
                prevEl: this.prevEl,
                nextEl: this.nextEl,
            };
        }

        this.swiper = new Swiper(this.slider, swiperOptions);
    }

    initSliderCards() {
        if (!this.slider) return;

        const swiperOptions = {
            modules: [Pagination, EffectCards],
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: true,
            loop: true,
            effect: 'cards',
            cardsEffect: {
                perSlideOffset: 8,
                perSlideRotate: 4,
                slideShadows: false,
            },
            pagination: {
                el: this.pagination,
                type: 'bullets',
                bulletClass: 'slider-pagination__bullet',
                bulletActiveClass: 'active',
            },
        };

        this.swiper = new Swiper(this.slider, swiperOptions);
    }

    initDescriptionSlider() {
        if (!this.descriptions) return;

        this.descSwiper = new Swiper(this.descriptions, {
            speed: 500,
            modules: [EffectFade],
            slidesPerView: 1,
            effect: 'fade',
            allowTouchMove: false,
        });
    }

    initWindow() {
        window.addEventListener('resize', this.onResize.bind(this));
        this.onResize();
    }

    onResize() {
        const { innerWidth } = window;

        if (this.swiper) {
            this.swiper.destroy();
            this.swiper = null;
        }

        if (innerWidth > 768) {
            this.initSlider();
        } else {
            this.initSliderCards();
        }

        if (this.swiper) {
            this.swiper.on('slideChange', swiper => {
                const { realIndex } = swiper;
                this.descSwiper.slideTo(realIndex);
            });
        }
    }
}

const initEventsSliders = () => {
    const sections = document.querySelectorAll('[data-events-slider-block]');
    if (sections) sections.forEach(item => new EventsSlider(item));
};

initEventsSliders();

(function () {
    const dataLayer = (window.dataLayer = window.dataLayer || []);

    // Helper do wyciągania danych eventów z karuzeli
    function extractItemsFromCarousel(carouselEl) {
        const item_list_name = carouselEl.dataset.itemListName || '';
        const item_list_id = carouselEl.dataset.itemListId || '';

        const items = [...carouselEl.querySelectorAll('.event-card')].map(
            card => ({
                item_id: card.dataset.id || '',
                item_name: card.dataset.name || '',
                item_brand: card.dataset.brand || '',
                item_category: card.dataset.category || '',
                item_category2: card.dataset.subcategory || '',
                item_category3: card.dataset.city || '',
                item_category4: card.dataset.venue || '',
                item_list_name,
                item_list_id,
            })
        );

        return { items, item_list_name, item_list_id };
    }

    function trackViewItemList(carouselEl) {
        const { items, item_list_name, item_list_id } =
            extractItemsFromCarousel(carouselEl);

        if (items.length === 0) return; // nie wysyłaj pustych eventów

        dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                item_list_name,
                item_list_id,
                items,
            },
        });
    }

    function trackViewItem(cardEl, carouselEl) {
        if (!cardEl || !carouselEl) return;

        const item_list_name = carouselEl.dataset.itemListName || '';
        const item_list_id = carouselEl.dataset.itemListId || '';

        const item = {
            item_id: cardEl.dataset.id || '',
            item_name: cardEl.dataset.name || '',
            item_brand: cardEl.dataset.brand || '',
            item_category: cardEl.dataset.category || '',
            item_category2: cardEl.dataset.subcategory || '',
            item_category3: cardEl.dataset.city || '',
            item_category4: cardEl.dataset.venue || '',
            item_list_name,
            item_list_id,
        };

        dataLayer.push({
            event: 'view_item',
            ecommerce: {
                items: [item],
            },
        });
    }

    function trackSelectItem(cardEl, carouselEl) {
        if (!cardEl || !carouselEl) return;

        const item_list_name = carouselEl.dataset.itemListName || '';
        const item_list_id = carouselEl.dataset.itemListId || '';

        const item = {
            item_id: cardEl.dataset.id || '',
            item_name: cardEl.dataset.name || '',
            item_brand: cardEl.dataset.brand || '',
            item_category: cardEl.dataset.category || '',
            item_category2: cardEl.dataset.subcategory || '',
            item_category3: cardEl.dataset.city || '',
            item_category4: cardEl.dataset.venue || '',
            item_list_name,
            item_list_id,
        };

        dataLayer.push({
            event: 'select_item',
            ecommerce: {
                items: [item],
            },
        });
    }

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5, // 50% widoczności karty
    };

    const viewedCards = new WeakSet();

    function onIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const card = entry.target;
                if (!viewedCards.has(card)) {
                    viewedCards.add(card);
                    const carousel = card.closest('[data-events-slider-block]');
                    trackViewItem(card, carousel);
                }
            }
        });
    }

    const observer = new IntersectionObserver(onIntersection, observerOptions);

    const carousels = document.querySelectorAll('[data-events-slider-block]');

    const viewedCarousels = new WeakSet();

    const carouselObserver = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const carousel = entry.target;
                    if (!viewedCarousels.has(carousel)) {
                        viewedCarousels.add(carousel);
                        trackViewItemList(carousel);
                    }
                }
            });
        },
        { threshold: 0.5 }
    );

    carousels.forEach(carousel => {
        carouselObserver.observe(carousel);

        const cards = carousel.querySelectorAll('.event-card');
        cards.forEach(card => observer.observe(card));

        carousel.addEventListener('click', e => {
            let target = e.target;
            while (target && !target.classList.contains('event-card')) {
                target = target.parentElement;
            }
            if (target && target.classList.contains('event-card')) {
                trackSelectItem(target, carousel);
            }
        });
    });
})();
